<template>
    <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
        <div class="container-fluid">

            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>
            <router-link class="navbar-brand" to="/">
                <img src="./../../assets/dreamfill.png" class="navbar-brand-img" alt="...">
            </router-link>

            <slot name="mobile-right">
                <ul class="nav align-items-center d-md-none">
                    <!-- <base-dropdown class="nav-item" position="right">
                        <a slot="title" class="nav-link nav-link-icon" href="#" role="button" data-toggle="dropdown"
                           aria-haspopup="true" aria-expanded="false">
                            <i class="ni ni-bell-55"></i>
                        </a>

                        <a class="dropdown-item" href="#">Action</a>
                        <a class="dropdown-item" href="#">Another action</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="#">Something else here</a>
                    </base-dropdown> -->
                    <base-dropdown class="nav-item" position="right">
                        <a slot="title" class="nav-link" href="#" role="button">
                            <div class="media align-items-center">
                              <span class="avatar avatar-sm rounded-circle">
                                <img alt="Image placeholder" src="img/theme/empty_profile.png">
                              </span>
                            </div>
                        </a>

                        <!-- <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Welcome!</h6>
                        </div> -->
                        <button class="dropdown-item" @click="modals.modal3 = true; show = false; currentPassword = ''; newPassword = ''; confirmPassword = ''">
                            <i class="ni ni-single-02"></i>
                            <span>My profile</span>
                        </button>
                        <a href="#!" class="dropdown-item">
                            <i class="ni ni-user-run"></i>
                            <span>Logout</span>
                        </a>
                    </base-dropdown>
                </ul>
            </slot>
            <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <img src="./../../assets/dreamfill.png">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul class="navbar-nav">
                    <slot name="links">
                    </slot>
                </ul>
                <!--Divider-->
                <!-- <hr class="my-3"> -->
                <!--Heading-->
                <!-- <h6 class="navbar-heading text-muted">Documentation</h6> -->
                <!--Navigation-->
                <!-- <ul class="navbar-nav mb-md-3">
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://demos.creative-tim.com/vue-argon-dashboard/documentation">
                            <i class="ni ni-spaceship"></i> Getting started
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://demos.creative-tim.com/vue-argon-dashboard/documentation/foundation/colors.html">
                            <i class="ni ni-palette"></i> Foundation
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           href="https://demos.creative-tim.com/vue-argon-dashboard/documentation/components/alerts.html">
                            <i class="ni ni-ui-04"></i> Components
                        </a>
                    </li>
                </ul> -->
            </div>
        </div>
        
        <div class="row" id="div-edit-admin-profile">
            <div class="col-md-4">
                <modal :show.sync="modals.modal3"
                   body-classes="p-0"
                   modal-classes="modal-dialog-centered modal-lg">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-4"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <template>
                            <div slot="header" class="bg-white border-0">
                                <div class="row align-items-center">
                                    <div class="col-8">
                                        <h3 class="mb-0">ADMIN PROFILE</h3>
                                    </div>
                                </div>
                            </div>
                            <form @submit.prevent>
                                <div>
                                    <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <base-input alternative=""
                                                        label="Name"
                                                        placeholder="Name"
                                                        input-classes="form-control-alternative"
                                                        v-model="name"
                                                        :disabled="true"
                                            />
                                        </div>
                                    </div>
                                    <hr class="my-4" />
                                    <h6 class="heading-small text-muted mb-4">Change Password</h6>
                                    <div>
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <base-input alternative=""
                                                            label="Current Password"
                                                            placeholder="Current Password"
                                                            input-classes="form-control-alternative"
                                                            type="password"
                                                            v-model="currentPassword"
                                                />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <base-input alternative=""
                                                            label="New Password"
                                                            placeholder="New Password"
                                                            input-classes="form-control-alternative"
                                                            type="password"
                                                            v-model="newPassword"
                                                />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <base-input alternative=""
                                                            label="Confirm Password"
                                                            placeholder="Confirm Password"
                                                            input-classes="form-control-alternative"
                                                            type="password"
                                                            v-model="confirmPassword"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center">
                                        <base-button type="danger" class="my-4" @click="modals.modal3 = false">Cancel</base-button>
                                        <base-button type="success" class="my-4" @click="changePassword()">Update</base-button>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </card>
                </modal>
            </div>
        </div>

    </nav>
</template>
<script>
  import NavbarToggleButton from '@/components/NavbarToggleButton'

  export default {
    name: 'sidebar',
    data() {
      return {
        show: true,
        message: 'Something is wrong.',
        modals: {
            modal3: false
        },
        name: 'Administrator',
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      };
    },
    components: {
      NavbarToggleButton
    },
    props: {
      logo: {
        type: String,
        default: './../../assets/dreamfill.png',
        description: 'Sidebar app logo'
      },
      autoClose: {
        type: Boolean,
        default: true,
        description: 'Whether sidebar should autoclose on mobile when clicking an item'
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      };
    },
    methods: {
      closeSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      showSidebar() {
        this.$sidebar.displaySidebar(true)
      },
      logOut() {
        localStorage.removeItem('access_token');
        this.$router.push('login');
      },
      changePassword() {
        this.$store.dispatch('changePassword', {
            OldPassword: this.currentPassword,
            NewPassword: this.newPassword,
            ConfirmPassword: this.confirmPassword
        }).then (response => {
          if (response.status == 200) {
            this.modals.modal3 = false;
          } else {
            this.show = true;
          }
        }).catch (error => {
            for (var item in error.response.data) {

                if (error.response.data[item] != 'The request is invalid.') {
                    for (var item2 in error.response.data[item]) {
                        this.message = error.response.data[item][item2][0];
                        break;
                    }
                    break;
                }
                // console.log(error.response.data[item]);
            }
                

            this.show = true;
        });
      }
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    }
  };
</script>
